module.exports = __webpack_public_path__ + "static/media/ikebukuro-hanakawado-7.12f6f4b8.jpg";